import create from "zustand";
export const usePostgres = create((set) => ({
    showPostgreTeachingBubble: false,
    showResetPasswordBubble: false,
    setShowPostgreTeachingBubble: (showPostgreTeachingBubble) => set({ showPostgreTeachingBubble }),
    setShowResetPasswordBubble: (showResetPasswordBubble) => set({ showResetPasswordBubble }),
}));
